/**
 * Strip nested product data to the fields the order create/update endpoints use
 * (validation, pricing, zones, special-order flags). Keeps request bodies smaller.
 *
 * @param {object|null|undefined} product Product from the order line form
 * @returns {object|null}
 */
export function slimProductForOrderSubmit (product) {
    if (!product) return null;
    const subproducts = (product.subproducts || []).map((sp) => ({
        qty: sp.qty,
        subproduct_id: sp.subproduct_id,
        subproduct: sp.subproduct ? {
            id: sp.subproduct.id,
            stock: sp.subproduct.stock,
            allow_oversell: sp.subproduct.allow_oversell,
            gift_card: sp.subproduct.gift_card,
        } : null,
    }));
    return {
        id: product.id,
        stock: product.stock,
        require_subitem_quantities: product.require_subitem_quantities,
        cost: product.cost,
        zone: product.zone,
        special_order: product.special_order,
        special_order_lead_hours: product.special_order_lead_hours,
        category_id: product.category_id,
        subproducts,
    };
}
